export default "/assets/404.png";